import React from "react";
import { Col, Row } from "react-bootstrap";
import ActiveLoans from "./ActiveLoans";
import HistoricalLoans from "./HistoricalLoans";
var Funding = function () {
    return (React.createElement(React.Fragment, null,
        React.createElement(Row, null,
            React.createElement(Col, { lg: 12 },
                React.createElement(ActiveLoans, null)),
            React.createElement(Col, { lg: 12 },
                React.createElement(HistoricalLoans, null)))));
};
export default Funding;
